import { ReactComponent as LogoWhite } from "./images/svg/LogoWhite.svg";

const IconSvg = {
    LogoWhite
}


export default IconSvg